import { render } from "./CRMWhatsappContactAddressDialog.vue?vue&type=template&id=0d815466&scoped=true"
import script from "./CRMWhatsappContactAddressDialog.vue?vue&type=script&lang=js"
export * from "./CRMWhatsappContactAddressDialog.vue?vue&type=script&lang=js"

import "./CRMWhatsappContactAddressDialog.vue?vue&type=style&index=0&id=0d815466&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d815466"]])

export default __exports__